export default "__VITE_ASSET__BqUNFG$b__";